const BROWSER_EXTENSION = '-extension://';
const ANONYMOUS = '<anonymous>';

export const hasExtensionReferenceInHintErrorStack = (hint) =>
  hint?.originalException?.stack?.includes(BROWSER_EXTENSION);

export const hasExtensionReferenceInBreadCrumbs = (event) =>
  !!event?.breadcrumbs?.find((entry) =>
    entry.data?.url?.includes(BROWSER_EXTENSION)
  );

export const hasExtensionReferenceInEventErrorStack = (event) => {
  return !!event?.exception?.values?.find((entry) => {
    return !!entry.stacktrace?.frames?.find(
      (frame) =>
        frame?.filename?.includes(BROWSER_EXTENSION) ||
        frame?.abs_path?.includes(BROWSER_EXTENSION) ||
        frame?.filename?.includes(ANONYMOUS) ||
        frame?.abs_path?.includes(ANONYMOUS)
    );
  });
};

export default {
  hasExtensionReferenceInHintErrorStack,
  hasExtensionReferenceInBreadCrumbs,
  hasExtensionReferenceInEventErrorStack
};
